import { query, collection, orderBy, onSnapshot, addDoc, setDoc, doc, deleteDoc } from "firebase/firestore";
import { getCompanyId, db, getCurrentUser, sendError } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: any[] = [];

export function registerResourceSnapshotListener() {
    if (snapshotListener !== null){
        return;
    }
    const q = query(collection(db, 'companies/' + getCompanyId() + '/resources'), orderBy("name"));
    //console.log("register resourceListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: { resourceId: any; resourceTitle: any; }[] = [];
        data.forEach(function (doc: any) {
            //resource musi być stringiem
           
                list.push({ resourceId: doc.id + "", resourceTitle: doc.data().name });
            
        });
        lastSnapshotList = list;
        listeners.forEach(callback => {
            callback(list);
        });


    }, (err) => {
        console.log("onResourcesChange error => " + err.message);
        sendError(err.message);
    })
}
export async function unregisterResourceSnapshotListener(){
    if (snapshotListener !== null) {
        //console.log("unregister resourceListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addResourceListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotList.length > 0) {
        callback(lastSnapshotList);
    }
}

export async function addResource(data:{name:string}){
    try {
        await addDoc(collection(db, 'companies/' + getCompanyId() + '/resources'), data);
    } catch (error) {
        console.error(error);
        sendError("Nie mozna dodać Pokoju!");
    }
}

export async function setResource(data:{name:string}, id: string){
    try {
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/resources', id), data, { merge: true });
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić Pokoju!");
    }
}

export async function deleteResource(id:string){
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/resources', id));
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć Pokoju!");
    }
}

export function getResources() {
    return lastSnapshotList;
}

export function getResource(id: string) {
    for(var i=0; i<lastSnapshotList.length; i++){
        if(lastSnapshotList[i].id === id){
            return lastSnapshotList[i];
        }
    }
    return null;

}